import BackgroundDecor from '../components/layout/BackgroundDecor';
import SiteFooter from '../components/layout/SiteFooter';
import CtaSection from '../components/sections/CtaSection';
import HeroSection from '../components/sections/HeroSection';
import ServicesSection from '../components/sections/ServicesSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import { highlights, services, testimonials } from '../data/homePageData';

function HomePage() {
  return (
    <div className="relative overflow-hidden bg-brand-bg">
      <BackgroundDecor />

      <main className="relative mx-auto max-w-7xl px-6 pb-16 sm:px-8 sm:pb-24">
        <HeroSection highlights={highlights} />
        <ServicesSection services={services} />
        <TestimonialsSection testimonials={testimonials} />
        <CtaSection />
      </main>

      <SiteFooter />
    </div>
  );
}

export default HomePage;